import { SelectListItem } from "@molecules/Select/SelectListItem/SelectListItem.types"
import { Select } from "@molecules/index"

import { BottomSheetItemBase } from "@organisms/BottomSheet/BottomSheetItem/BottomSheetItem"

import {
    JobTimelineScheduler,
    TimelineViewTimeFrames,
} from "@pages/Jobs/JobList/views/JobTimelineView/JobTimelineView.types"
import timelineViewMenuStyles from "@pages/Jobs/JobList/views/JobTimelineView/TimelineViewMenu/TimelineViewMenuBottomSheet/TimelineViewMenuBottomSheet.module.scss"
import useJobTimelineViewBryntumInstances from "@pages/Jobs/JobList/views/JobTimelineView/hooks/useJobTimelineViewBryntumInstances"
import useJobTimelineViewData from "@pages/Jobs/JobList/views/JobTimelineView/hooks/useJobTimelineViewData"
import useJobTimelineViewStates from "@pages/Jobs/JobList/views/JobTimelineView/hooks/useJobTimelineViewStates"

import styles from "./TimelineViewTimeFrameSelector.module.scss"

export const timeFrameOptions: SelectListItem<TimelineViewTimeFrames>[] = [
    {
        value: "day",
        label: "Day",
    },
    {
        value: "threeDays",
        label: "3 days",
    },
    {
        value: "week",
        label: "Week",
    },
    {
        value: "month",
        label: "Month",
    },
]

const timeFrameTypeLabelMap: { [key in TimelineViewTimeFrames]: string } = {
    day: "Day",
    threeDays: "3 days",
    week: "Week",
    month: "Month",
}

const useOnSelect = () => {
    const { setTimeFrameType } = useJobTimelineViewStates()
    const { schedulerPro } = useJobTimelineViewBryntumInstances()
    const { addResourceTimeRangesToScheduler, narrowDateRangeToCenterDate } = useJobTimelineViewData()

    const onSelect = (item: SelectListItem<TimelineViewTimeFrames>) => {
        const schedulerInstance = schedulerPro.current?.instance as JobTimelineScheduler
        if (schedulerInstance) {
            schedulerInstance.infiniteScroll = false
            schedulerInstance.resourceColumns?.refresh()
        }

        if (item.value === "day") {
            addResourceTimeRangesToScheduler()
        }

        narrowDateRangeToCenterDate()
        setTimeFrameType(item.value)
    }

    return {
        onSelect,
    }
}

function TimelineViewTimeFrameBottomSheet() {
    const { timeFrameType } = useJobTimelineViewStates()

    const { onSelect } = useOnSelect()

    return (
        <div className={timelineViewMenuStyles.content}>
            {timeFrameOptions.map((item) => (
                <BottomSheetItemBase
                    key={item.value}
                    isTabbable={true}
                    label={item.label}
                    isSelected={timeFrameType === item.value}
                    onClick={() => onSelect(item)}
                />
            ))}
        </div>
    )
}

function TimelineViewTimeFrameSelect() {
    const { timeFrameType } = useJobTimelineViewStates()

    const { onSelect } = useOnSelect()

    return (
        <div className={styles.selectWidth}>
            <Select.Root>
                <Select.Input
                    isControlled={false}
                    selectedItem={{ value: timeFrameType, label: timeFrameTypeLabelMap[timeFrameType] }}
                    placeholder="Placeholder"
                    size="sm"
                    className={styles.selectWidth}
                />
                <Select.Viewport>
                    <Select.List className={styles.selectWidth} title="Select time frame">
                        <Select.ListGroup>
                            {timeFrameOptions.map((item) => (
                                <Select.ListItem
                                    variant="default"
                                    key={item.value}
                                    item={item}
                                    onSelect={() => onSelect(item)}
                                    isSelected={timeFrameType === item.value}
                                />
                            ))}
                        </Select.ListGroup>
                    </Select.List>
                </Select.Viewport>
            </Select.Root>
        </div>
    )
}

export default {
    Select: TimelineViewTimeFrameSelect,
    BottomSheet: TimelineViewTimeFrameBottomSheet,
}
